import { dadosTipoLancamentoStyles } from './DadosTipoLancamento.style'

export function dadosTipoLancamentoIO() {
  return {
    styles: dadosTipoLancamentoStyles
  }
}

export type DadosTipoLancamentoIO = ReturnType<typeof dadosTipoLancamentoIO>
